import * as React from "react";
const SvgNewMonitoringAgentIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 40, fill: "none", viewBox: "0 0 40 40", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 20, cy: 20, r: 20, fill: "#defbff", style: {
  fill: "#defbff",
  fill: "color(display-p3 .8706 .9843 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#504f87", strokeLinecap: "round", strokeLinejoin: "round", d: "M14.5 20h11M20 14.5v11", style: {
  stroke: "#504f87",
  stroke: "color(display-p3 .3137 .3098 .5294)",
  strokeOpacity: 1
} }));
export default SvgNewMonitoringAgentIcon;
